export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">精心策划的影视专题，按口味挑选你的专属片单</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">

          {/* Card 1 - 大卡片 */}
          <div className="lg:col-span-2 lg:row-span-2 group relative rounded-2xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/9] lg:aspect-auto lg:h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20popular%20movies%20and%20TV%20shows%20floating%20in%20warm%20theater%20lighting%2C%20film%20posters%20mosaic%2C%20rich%20coral%20and%20amber%20tones%2C%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20no%20text&width=1200&height=800&seq=index-collection-01&orientation=landscape"
                alt="本月必看精选"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent flex flex-col justify-end p-5 md:p-6">
              <span className="text-xs font-medium text-primary-300 bg-primary-500/20 px-3 py-1 rounded-full inline-block w-fit mb-2 whitespace-nowrap">编辑精选</span>
              <h3 className="text-lg md:text-xl font-bold text-white mb-1">本月必看精选</h3>
              <p className="text-xs text-foreground-300">编辑团队每月精选 30 部最值得观看的影视作品</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20detective%20board%20and%20red%20strings%20connecting%20clues%2C%20film%20noir%20aesthetic%2C%20warm%20dramatic%20lighting%2C%20cinematic%20mood%2C%20no%20text&width=640&height=400&seq=index-collection-02&orientation=landscape"
                alt="悬疑烧脑专场"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
              <span className="text-xs font-medium text-accent-300 bg-accent-500/20 px-2 py-0.5 rounded-full inline-block w-fit mb-1 whitespace-nowrap">高分推荐</span>
              <h3 className="text-sm font-semibold text-white">悬疑烧脑专场</h3>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20room%20with%20sunlight%20streaming%20through%20window%2C%20soft%20pastel%20coral%20tones%2C%20calm%20peaceful%20atmosphere%2C%20lifestyle%20photography%2C%20no%20text&width=640&height=400&seq=index-collection-03&orientation=landscape"
                alt="治愈系日剧"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
              <span className="text-xs font-medium text-accent-300 bg-accent-500/20 px-2 py-0.5 rounded-full inline-block w-fit mb-1 whitespace-nowrap">暖心推荐</span>
              <h3 className="text-sm font-semibold text-white">治愈系日剧</h3>
            </div>
          </div>

          {/* Card 4 */}
          <div className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20explosion%20scene%20silhouette%2C%20warm%20orange%20and%20red%20fire%20tones%2C%20cinematic%20wide%20shot%2C%20dramatic%20intense%20atmosphere%2C%20no%20text&width=640&height=400&seq=index-collection-04&orientation=landscape"
                alt="动作爽片合集"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
              <span className="text-xs font-medium text-accent-300 bg-accent-500/20 px-2 py-0.5 rounded-full inline-block w-fit mb-1 whitespace-nowrap">肾上腺素</span>
              <h3 className="text-sm font-semibold text-white">动作爽片合集</h3>
            </div>
          </div>

          {/* Card 5 */}
          <div className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20architecture%20silhouette%20at%20sunset%20with%20warm%20golden%20light%2C%20dramatic%20sky%2C%20cinematic%20composition%2C%20epic%20atmosphere%2C%20no%20text&width=640&height=400&seq=index-collection-05&orientation=landscape"
                alt="国产剧口碑榜"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
              <span className="text-xs font-medium text-accent-300 bg-accent-500/20 px-2 py-0.5 rounded-full inline-block w-fit mb-1 whitespace-nowrap">国剧之光</span>
              <h3 className="text-sm font-semibold text-white">国产剧口碑榜</h3>
            </div>
          </div>

          {/* Card 6 */}
          <div className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20romantic%20scene%20with%20cherry%20blossoms%20and%20warm%20sunset%20light%2C%20dreamy%20bokeh%20effect%2C%20tender%20atmosphere%2C%20film%20aesthetic%2C%20no%20text&width=640&height=400&seq=index-collection-06&orientation=landscape"
                alt="浪漫爱情片"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
              <span className="text-xs font-medium text-accent-300 bg-accent-500/20 px-2 py-0.5 rounded-full inline-block w-fit mb-1 whitespace-nowrap">甜到上头</span>
              <h3 className="text-sm font-semibold text-white">浪漫爱情片</h3>
            </div>
          </div>

          {/* Card 7 */}
          <div className="group relative rounded-xl overflow-hidden cursor-pointer bg-background-100 border border-background-200/60">
            <div className="aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Vintage%20world%20map%20with%20warm%20ambient%20lighting%2C%20explorer%20aesthetic%2C%20rich%20textures%2C%20documentary%20film%20style%2C%20educational%20vibe%2C%20no%20text&width=640&height=400&seq=index-collection-07&orientation=landscape"
                alt="纪录片精选"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
              <span className="text-xs font-medium text-accent-300 bg-accent-500/20 px-2 py-0.5 rounded-full inline-block w-fit mb-1 whitespace-nowrap">涨知识</span>
              <h3 className="text-sm font-semibold text-white">纪录片精选</h3>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}